import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import SessionWatch from './components/SessionWatch';
import AppRoutes from './router';
import { store } from './store';
import { client } from './apollo';

/**
 * KeepInvesting MFD & PMS app — the composition root.
 *
 * The whole application as one renderable component: state, transport and
 * routing providers around the route table (router.js). index.js does nothing
 * but mount this, so the tree is testable and hot-reloads without remounting.
 *
 * The back-office admin console this repo was seeded from is the app_admin
 * submodule; its pages were removed from this tree once the PMS design took
 * over the route table.
 */
export default function App() {
  return (
    <Provider store={store}>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <ErrorBoundary>
            {/* Inside the providers (it needs both) and outside the routes, so
                a token dying on any screen ends the session. */}
            <SessionWatch />
            <AppRoutes />
          </ErrorBoundary>
        </BrowserRouter>
      </ApolloProvider>
    </Provider>
  );
}
